import { render, staticRenderFns } from "./trendlsc.vue?vue&type=template&id=3599bf49"
import script from "./trendlsc.vue?vue&type=script&lang=js"
export * from "./trendlsc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports